export const LanguagesInToronto = [
  {
    heading: "Spanish",
    detail:
      "Tomedes translation services will fulfill your Spanish translation needs by providing a specific Spanish translator. There are approximately 127,825 Spanish speakers in Toronto. Reach out to these Toronto residents and to Spanish-speaking places beyond Toronto with a Spanish translator from Tomedes.   ",
    link: "/spanish-translation.php",
  },
  {
    heading: "French",
    detail:
      "As the official language of Toronto, the French language is known by a majority of Toronto's residents. Communicating with the majority of the populace with French translation services is just the start of how translation can benefit you, especially if you're thinking about expanding globally. Get started now.",
    link: "/french-translation.php",
  },
  {
    heading: "Italian",
    detail:
      "Spoken by 71,725 people in Toronto, Italian is another major language of this city. An Italian translator can translate your documents, an Italian localizer can localize your apps, and an Italian interpreter can deliver. Whatever you need in terms of translation services, contact Tomedes now.",
    link: "/italian-translation.php",
  },
  {
    heading: "Portuguese",
    detail:
      "Portuguese is another popular language in Toronto. At Tomedes, a native-language Portuguese translator will work with you on your translation projects, providing you with industry expertise within your niche. Want to learn more about Portuguese translations? Contact us now.",
    link: "/portuguese-translation.php",
  },
  {
    heading: "Russian",
    detail:
      "23,935 Toronto residents speak Russian, and a Russian translator can provide you with translation, localization, and interpretation services for your personal or business needs. If you need a document translated into Russian, don't hesitate to talk to Tomedes",
    link: "/russian-translation.php",
  },
  {
    heading: "Japanese",
    detail:
      "At Tomedes, our Japanese translators are highly skilled with the language, as well as Japan's dialects. To top it all off, they're also instrumental in their business industries, which makes our Japanese translators one to beat. If you're interested in learning more, get in touch with Tomedes now.",
    link: "/japanese-translation.php",
  },
];
